import { render, staticRenderFns } from "./Registro_token.vue?vue&type=template&id=880c1bf2&"
import script from "./Registro_token.vue?vue&type=script&lang=js&"
export * from "./Registro_token.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports